/**
 * Centralized ID generation. Use for trips, days, places, transports, etc.
 * Prefixed variants for device IDs, template IDs, etc.
 */
export function generateId(): string {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}

export function generatePrefixedId(prefix: string): string {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}
